import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import {CookieService} from "ngx-cookie-service";
import {Router} from "@angular/router";
import {QdmService} from "../Services/qdm.service";
import {GestionService} from "../Services/gestion.service";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../Services/auth.service";
import {Subscription} from "rxjs";

@Component({
  standalone: true,
  selector: "OrderFailedCallback",
  templateUrl: "./OrderSuccessCallback.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./OrderSuccessCallback.component.scss"]
})
export class OrderFailedCallback implements OnInit, OnDestroy {
  private cookie = inject(CookieService);
  private router = inject(Router);
  private qdm = inject(QdmService);
  private gestion = inject(GestionService);
  private toast = inject(ToastrService);
  private auth = inject(AuthService);

  sub: Subscription = new Subscription();

  ngOnInit(){
    if(!this.cookie.check("lastOrderRestaurant")){
      this.router.navigate(["/"]);
      return;
    }

    const lastOrderRestaurant = this.cookie.get("lastOrderRestaurant");
    this.cookie.delete("lastOrderRestaurant", "/");

    this.qdm.listRestaurantsForCurrentDomain();
    this.sub.add(this.qdm.restaurants$.subscribe(restaurants => {
      if(restaurants.length === 0){return;}
      console.log(restaurants);
      const restaurant = restaurants.find((restaurant) => restaurant.id === parseInt(lastOrderRestaurant));
      if(!restaurant){
        this.router.navigate(["/"]);
        return;
      }

      this.qdm.selectRestaurant(restaurant);
      this.router.navigate(["/restaurant", lastOrderRestaurant]);

      this.toast.info("Votre commande a bien été enregistrée !", "Commande enregistrée", { positionClass: "toast-bottom-right-cart" });
    }));

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
